var _polygon, _polygon2, _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_waiting-for-keys") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.52 24.94 13.48 24.94 14.66 11.99 17.34 11.99 18.52 24.94",
    fill: "#f79422"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "18.52 24.94 13.48 24.94 14.66 11.99 17.34 11.99 18.52 24.94",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 22.38,
    width: 6.21,
    height: 9.39,
    rx: 1,
    ry: 1,
    transform: "translate(43.08 11.08) rotate(90)",
    fill: "#f79422"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.19,2.15c-1.33-1.18-3.53-1.15-5-1,0,0.56,0,1.3,0,2.16,1.17-.18,2.82-0.23,3.52.4a1.44,1.44,0,0,1,.34,1.45c-0.48,3.6-1.93,6.39-3.05,7a0.57,0.57,0,0,1-.56.07,3.91,3.91,0,0,0-1.34-.34,18.15,18.15,0,0,1-.78,2.27,1.31,1.31,0,0,1,1.25,0,2.68,2.68,0,0,0,2.47-.16c2.22-1.24,3.67-5.22,4.13-8.6A3.55,3.55,0,0,0,29.19,2.15Z",
    fill: "#f79422"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.24,1.19c0-.75-0.05-1.19-0.05-1.19H15.95V19.26c3.23,0,5.22-2.16,6.44-5a18.15,18.15,0,0,0,.78-2.27,36.36,36.36,0,0,0,1.09-8.6C24.26,2.49,24.26,1.75,24.24,1.19Z",
    fill: "#f79422"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81,2.15C4.14,1,6.33,1,7.76,1.19c0,0.56,0,1.3,0,2.16-1.17-.18-2.82-0.23-3.52.4A1.44,1.44,0,0,0,3.88,5.2c0.48,3.6,1.93,6.39,3.05,7a0.57,0.57,0,0,0,.56.07,3.91,3.91,0,0,1,1.34-.34,18.15,18.15,0,0,0,.78,2.27,1.31,1.31,0,0,0-1.25,0,2.68,2.68,0,0,1-2.47-.16c-2.22-1.24-3.67-5.22-4.13-8.6A3.55,3.55,0,0,1,2.81,2.15Z",
    fill: "#f79422"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76,1.19C7.78,0.44,7.81,0,7.81,0h8.24V19.26c-3.23,0-5.22-2.16-6.44-5a18.15,18.15,0,0,1-.78-2.27,36.36,36.36,0,0,1-1.09-8.6C7.74,2.49,7.74,1.75,7.76,1.19Z",
    fill: "#f79422"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 21.06,
    width: 6.21,
    height: 15.68,
    rx: 1,
    ry: 1,
    transform: "translate(44.9 12.9) rotate(90)",
    fill: "#f79422"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 21.06,
    width: 6.21,
    height: 15.68,
    rx: 1,
    ry: 1,
    transform: "translate(44.9 12.9) rotate(90)",
    opacity: 0.1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,12.28a0.57,0.57,0,0,0,.56-0.07c1.12-.63,2.57-3.43,3.05-7a1.44,1.44,0,0,0-.34-1.45c-0.7-.63-2.35-0.58-3.52-0.4a36.36,36.36,0,0,1-1.09,8.6A3.91,3.91,0,0,1,24.5,12.28Z",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.19,2.15c-1.33-1.18-3.53-1.15-5-1,0,0.56,0,1.3,0,2.16,1.17-.18,2.82-0.23,3.52.4a1.44,1.44,0,0,1,.34,1.45c-0.48,3.6-1.93,6.39-3.05,7a0.57,0.57,0,0,1-.56.07,3.91,3.91,0,0,0-1.34-.34,18.15,18.15,0,0,1-.78,2.27,1.31,1.31,0,0,1,1.25,0,2.68,2.68,0,0,0,2.47-.16c2.22-1.24,3.67-5.22,4.13-8.6A3.55,3.55,0,0,0,29.19,2.15Z",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76,1.19C7.78,0.44,7.81,0,7.81,0h8.24V19.26c-3.23,0-5.22-2.16-6.44-5a18.15,18.15,0,0,1-.78-2.27,36.36,36.36,0,0,1-1.09-8.6C7.74,2.49,7.74,1.75,7.76,1.19Z",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.04,
    y: 26.76,
    width: 13.91,
    height: 4.28,
    fill: "#b3b3b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestComplete);
export default __webpack_public_path__ + "static/media/request_complete.6782c46915ad847c9ca2f8a3357d827d.svg";
export { ForwardRef as ReactComponent };